import api from "../api";
import business_id from "../business"

export default {
  namespaced: true,
  state: {
    categories: {},
    category: {},
    collections: {},
    paginate: {},
    child_categories: {},
    tcg_categories: {},
    collection_categories: {},
    category_child: {}
  },
  getters: {
    
  },
  actions: {
    async get_categories({ commit }) {
      try {
        api.get(`/v1/${business_id}/categories`)
          .then((res) => {
            commit("GET_CATEGORIES", res.data);
          })
          .catch((error) => {
            commit("ERROR_CATEGORY", "Erro ao carregar as categorias");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CATEGORY", e);
      }
    },

    async get_category({ commit }, id) {
      try {
        api.get(`/v1/${business_id}/categories/${id}`)
          .then((res) => {
            commit("GET_CATEGORY", res.data);
          })
          .catch((error) => {
            commit("ERROR_CATEGORY", "Erro ao carregar categoria");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CATEGORY", e);
      }
    },
    
    async get_collection({ commit }, category_id) {
      try {
        api.get(`/v1/categories/${category_id}`)
          .then((res) => {
            commit("GET_COLLECTION", res.data);
          })
          .catch((error) => {
            commit("ERROR_COLLECTION", "Erro ao carregar as collections");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_COLLECTION", e);
      }
    },

    async get_collection_navbar({ commit },  payload = []) {
      try {
        await api.post(`/v1/paginate-categories`, payload)
        .then((res) => {
          commit("GET_PAGINATE_COLLECTION", res.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (
          // this.loading = false
          console.log('login request end')
        ));
      } catch (e) {
        console.log(e);
      }
    },

    async get_tcg_navbar({ commit },  payload = []) {
      try {
        await api.post(`/v1/paginate-categories`, payload)
        .then((res) => {
          commit("GET_PAGINATE_TCG", res.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (
          // this.loading = false
          console.log('login request end')
        ));
      } catch (e) {
        console.log(e);
      }
    },

    async get_paginate_categories({ commit }, payload = []) {
      try {
        await api.post(`/v1/paginate-categories`, payload)
        .then((res) => {
          commit("GET_PAGINATE_CATEGORIES", res.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (
          // this.loading = false
          console.log('login request end')
        ));
      } catch (e) {
        console.log(e);
      }
    },

    async get_category_childs({ commit }, category_id) {
      try {
        api.get(`/v1/categories/${category_id}`)
          .then((res) => {
            commit("GET_CATEGORY_CHILDS", res.data);
          })
          .catch((error) => {
            commit("ERROR_CATEGORY_CHILDS", "Erro ao carregar os child da categoria");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CATEGORY_CHILD", e);
      }
    },
  
  },
  mutations: {
    GET_CATEGORIES(state, data) {
      state.categories = data
    },
    GET_CATEGORY(state, data) {
      state.category = data
    },
    ERROR_CATEGORY(state, data) {
      console.log(data)
    },

    GET_COLLECTION(state, data) {
      state.collections = data
    },
    ERROR_COLLECTION(state, data) {
      console.log(data)
    },

    GET_PAGINATE_CATEGORIES(state, data) {
      if (data?.paginate.current_page == 1) {
        state.child_categories = data?.products; 
      } else {
        state.child_categories.push(...data?.products); 
      }
      state.paginate = data?.paginate;
    },

    GET_PAGINATE_TCG(state, data) {
      if (data?.paginate.current_page == 1) {
        state.tcg_categories = data?.products; 
      } else {
        state.tcg_categories.push(...data?.products); 
      }
      // state.paginate = data?.paginate;
    },

    GET_PAGINATE_COLLECTION(state, data) {
      if (data?.paginate.current_page == 1) {
        state.collection_categories = data?.products; 
      } else {
        state.collection_categories.push(...data?.products); 
      }
      // state.paginate = data?.paginate;
    },

    GET_CATEGORY_CHILDS(state, data) {
      state.category_child = data
    },
    ERROR_CATEGORY_CHILDS(state, data) {
      console.log(data)
    },
  }
}